module.exports = __webpack_public_path__ + "static/media/wnyc.113e252b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/wnyc.svg
// module id = 98
// module chunks = 0